import React from 'react';
import { Typography } from '@mui/material';
import { emptyReportSectionStyles } from './styles';

export default function EmptyReportSection({ children }) {
  return (
    <Typography variant="body2" color="text.secondary" sx={emptyReportSectionStyles}>
      {children}
    </Typography>
  );
}
